import React from "react";
import { FlatList, Platform, TextInputFocusEvent, TextInputProps, TouchableOpacity, UIManager, ViewStyle } from "react-native"
import Input from ".."
import { SPopup, SText, STheme, SThread, SView } from "servisofts-component2";

const similitud = (a: any, b: any) => {
    const matrix = Array.from({ length: a.length + 1 }, () =>
        Array(b.length + 1).fill(0)
    );

    for (let i = 0; i <= a.length; i++) matrix[i][0] = i;
    for (let j = 0; j <= b.length; j++) matrix[0][j] = j;

    for (let i = 1; i <= a.length; i++) {
        for (let j = 1; j <= b.length; j++) {
            matrix[i][j] = a[i - 1] === b[j - 1]
                ? matrix[i - 1][j - 1]
                : Math.min(
                    matrix[i - 1][j] + 1,
                    matrix[i][j - 1] + 1,
                    matrix[i - 1][j - 1] + 1
                );
        }
    }

    const distancia = matrix[a.length][b.length];
    const longitudMax = Math.max(a.length, b.length);
    return (longitudMax - distancia) / longitudMax; // 0 a 1
}

const buscarFlexible = (lista: any, termino: any, umbral = 0.6) => {
    const normalizado = termino.toLowerCase();
    return lista.filter((p: any) => similitud(p.toLowerCase(), normalizado) >= umbral);
}


function indiceMasParecido(lista: any, palabra: any) {
    let maxSimilitud = -1;
    let mejorIndex = -1;
    const buscado = palabra.toLowerCase();

    lista.forEach((item: any, i: any) => {
        const sim = similitud(item.toLowerCase(), buscado);
        if (sim > maxSimilitud) {
            maxSimilitud = sim;
            mejorIndex = i;
        }
    });

    return mejorIndex;
}


export default (input: Input): TextInputProps => {
    // const contentRef = React.useRef<PopupSelect>(null);
    // const [state, setState] = /React.useState({
    const onFocus = (e: TextInputFocusEvent) => {
        if (input._ref.popup) {
            input._ref.popup.onFocus(e);
            return;
        }
        if (!e?.target?.measureInWindow) {
            new SThread(100, "measureInWindowError").start(() => {
                onFocus(e);
            })
            console.error("measureInWindow is not available on this platform", e.target.measureInWindow);
            return;
        }
        e.target.measure((x, y, width, height) => {
            input._ElementFooter = <PopupSelect ref={(ref: any) => input._ref.popup = ref}
                input={input} style={{
                    left: x,
                    top: y + height + 2,
                    width: width,
                }} />
            input.forceUpdate();
            // SPopup.open({
            //     key: "select_" + input.key,
            //     type: "3",
            //     content: <PopupSelect ref={(ref: any) => input._ref.popup = ref}
            //         input={input} style={{
            //             left: x,
            //             top: y + height + 2,
            //             width: width,
            //         }} />
            // })
        })

    }
    return {
        ...input.props,
        secureTextEntry: false,
        autoCapitalize: "none",
        onFocus: onFocus,
        onBlur: (e) => {
            if (input._ref.popup) {
                input._ref.popup.onBlur(e);
            }
        },
        onKeyPress: (e) => {
            if (input._ref.popup) {
                input._ref.popup.onKeyPress(e);
            }
        }
    }
}

class PopupSelect extends React.Component<{ style: ViewStyle, input: Input }> {

    indexSelected: number = 0;
    isFocused: boolean = true;
    flatList: FlatList | null = null;
    listenerCWU: any;
    listenerOnChangeText: any;
    componentDidMount(): void {
        this.listenerCWU = this.props.input.addEventListener("componentWillUnmount", () => {
            if (this.props.input._ref.popup) {
                this.props.input._ref.popup = null;
                this.close();
            }
        })
        this.listenerOnChangeText = this.props.input.addEventListener("onChangeText", (text: string) => {
            if (this.flatList) {
                if (this.props.input.props.type !== "select") return;
                // this.indexSelected = this.props.input.props.options.findIndex((item: string) => item.toLowerCase().startsWith(text.toLowerCase()));
                this.indexSelected = indiceMasParecido(this.props.input.props.options, text);
                if (this.indexSelected < 0) {
                    this.indexSelected = 0;
                }
                this.selectIndex(this.indexSelected, false);

            }
        });

        if (this.flatList) {
            if (this.props.input.props.type !== "select") return;
            this.indexSelected = this.props.input.props.options.findIndex((item: any) => item === this.props.input.state.value);
            if (this.indexSelected < 0) {
                this.indexSelected = 0;
            }
            this.selectIndex(this.indexSelected, false);
        }
    }

    close() {
        if (this.props.input._ElementFooter) {
            this.props.input._ElementFooter = null;
            this.props.input.forceUpdate();
        }
    }
    componentWillUnmount(): void {
        if (this.props.input._ref.popup) {
            this.props.input._ref.popup = null;
            this.props.input.removeEventListener("componentWillUnmount", this.listenerCWU);
            this.props.input.removeEventListener("onChangeText", this.listenerOnChangeText);
            this.close();
        }

    }
    selectIndex(index: number, animated: boolean = true) {
        if (this.props.input.props.type !== "select") return;
        if (index < 0 || index >= this.props.input.props.options.length) return;
        this.indexSelected = index;
        if (this.flatList) {
            this.flatList.scrollToIndex({ index: this.indexSelected, animated: animated });
        }
        this.forceUpdate();
    }
    onFocus(e: any) {
        this.isFocused = true;
    }
    onBlur(e: any) {
        this.isFocused = false;

        const { input, style } = this.props;
        new SThread(100, "popupSelectBlur", true).start(() => {
            if (!!this.isFocused) return;
            this.close();
            if (input.props.type != "select") return;
            input.setValue(input.props.options[this.indexSelected]);
            input.handleOnSubmitEditing({
                final:true
            } as any);
        })

    }
    onKeyPress(e: any) {

        // console.log("onKeyPress", e.nativeEvent.key);
        switch (e.nativeEvent.key) {
            case "ArrowUp":
                if (this.indexSelected > 0) {
                    this.indexSelected--;
                    this.selectIndex(this.indexSelected, false);
                }
                e.preventDefault();
                break;
            case "ArrowDown":
                if (this.props.input.props.type !== "select") return null;
                if (this.indexSelected < this.props.input.props.options.length - 1) {
                    this.indexSelected++;
                    this.selectIndex(this.indexSelected, false);
                }
                e.preventDefault();
                break;
        }
    }


    render() {
        const { input, style } = this.props;
        if (input.props.type !== "select") return null;
        return <FlatList
            nestedScrollEnabled
            style={{
                zIndex: 1000,
                width: 100,
                backgroundColor: STheme.color.background,
                borderWidth: 1,
                borderColor: STheme.color.card,
                borderRadius: 4,
                opacity: 0.95,
                height: 150,
                padding: 0,
                position: "absolute",
                elevation: 5,  // para Androi
                ...style,
            }}
            ref={(ref: any) => this.flatList = ref}
            data={input.props.options}
            showsVerticalScrollIndicator={false}
            keyboardDismissMode="none"
            keyboardShouldPersistTaps="always"
            keyExtractor={(item, index) => index.toString()}
            getItemLayout={(data, index) => (
                { length: 40, offset: 40 * index, index }
            )}
            contentContainerStyle={{
                width: "100%",
            }}
            renderItem={({ item, index }) => {
                const select = this.indexSelected === index;

                return <TouchableOpacity
                    style={{
                        width: "100%",
                        height: 40,
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: select ? STheme.color.text + "66" : "transparent",
                    }}
                    onPressIn={e => {
                        if (Platform.OS === "web") {
                            if (this.isFocused) return;
                            this.isFocused = true;
                            input.textInput?.focus();
                        }

                    }}
                    onPress={(e) => {
                        input.setValue(item);
                        this.selectIndex(index, true);
                        this.forceUpdate();
                        input.handleOnSubmitEditing({
                            final:true
                        } as any);
                        input.textInput?.blur();

                        // SPopup.close("select_" + input.key);
                    }}
                >
                    <SText>{item}</SText>
                </TouchableOpacity>
            }}
            ListHeaderComponent={() => {
                return <SView style={{ height: 40 }} />
            }}
            ListFooterComponent={() => {
                return <SView style={{ height: 40 }} />
            }}
        />
    }

}